import buildFormReducer from 'reducers/builders/form';
import actionTypes, { actionTypeSections } from 'actiontypes/';
import { combineReducers } from 'redux';

const mainInitialState = {
  isRequesting: false,
  showError: false,
};

const formInitialState = {
  email: {
    value: '',
    isValid: false,
    isValidating: false,
  },
};

function mainReducer(state = mainInitialState, action) {
  const actionType = action.type;

  switch (actionType) {
    case actionTypes.SSO_LOGIN_REQUEST.RESET_STATE:
      return { ...mainInitialState };
    case actionTypes.SSO_LOGIN_REQUEST.REQUEST_SSO_LOGIN_REQUEST:
      return {
        ...state,
        isRequesting: true,
      };
    case actionTypes.SSO_LOGIN_REQUEST.REQUEST_SSO_LOGIN_SUCCESS:
      return {
        ...state,
        isRequesting: false,
        showError: false,
      };
    case actionTypes.SSO_LOGIN_REQUEST.REQUEST_SSO_LOGIN_FAILURE:
      return {
        ...state,
        isRequesting: false,
        showError: true,
      };
    default:
      return state;
  }
}

const requestReducer = combineReducers({
  main: mainReducer,
  form: buildFormReducer(formInitialState, actionTypeSections.SSO_LOGIN_REQUEST),
});

export { requestReducer as default };
